import { formatChatMessageTime, useTranslation } from "hhn-commons";
import { MessageStatusProps } from "../RecipientMessageStatus";
import {
  MessageDeliveryStatusBox,
  MessageReadDeliveredIcon,
} from "./MessageStatus.style";

const MessageDeliveredStatus = ({
  timestamp,
  showText = true,
}: MessageStatusProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "chat" });

  return (
    <MessageDeliveryStatusBox data-testid="message-delivered-status">
      <MessageReadDeliveredIcon />
      {showText && `${tNs("messageInfo.messageDeliveredStatus")}, `}
      {timestamp && formatChatMessageTime(timestamp)}
    </MessageDeliveryStatusBox>
  );
};
export default MessageDeliveredStatus;
